import { render, staticRenderFns } from "./processDetails.vue?vue&type=template&id=17385163&scoped=true&"
import script from "./processDetails.vue?vue&type=script&lang=js&"
export * from "./processDetails.vue?vue&type=script&lang=js&"
import style0 from "./processDetails.vue?vue&type=style&index=0&id=17385163&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17385163",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17385163')) {
      api.createRecord('17385163', component.options)
    } else {
      api.reload('17385163', component.options)
    }
    module.hot.accept("./processDetails.vue?vue&type=template&id=17385163&scoped=true&", function () {
      api.rerender('17385163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/processDetails.vue"
export default component.exports